<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components :page="page"></progress-components>
      <v-row v-show="code == 101" justify="center" class="mb-8 my-6">
        <div class="text-body-1" style="font-weight: bold;">大変恐れ入りますが、対象者は13~64歳のため受診はできません。</div>
      </v-row>
      <v-row v-show="code == 102" justify="center" class="mb-8 my-6">
        <div class="text-body-1" style="font-weight: bold;">大変恐れ入りますが、重症化リスクに当てはまる方の受診はできません。</div>
      </v-row>
    </v-container>
    <v-container>
      <v-row justify="center" align-content="center" class="mb-6 btn-area">
        <v-btn
          dark
          color="#B0B6BA"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="toBack"
        >戻る
        </v-btn>
        <v-btn
          dark
          :disabled="isDisableSendBtn"
          x-large min-width="362px"
          color="doorAccentColor"
          class="mb-4 mx-4 white--text"
          @click="clickedSubmit"
        >終了
        </v-btn>
      </v-row>
    </v-container>
    <error-dialog :isOpen="isError"></error-dialog>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, ref, computed } from 'vue'
import { Logger } from 'aws-amplify'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/InterviewTitle.vue'
import ProgressComponents from '@/components/InterviewProgress.vue'
import ErrorDialog from '@/components/ErrorDialog.vue'
import { useScreenOperation } from '@/func/useScreenOperation'
import { useRequestConverter } from '@/func/useRequestConverter'

const logger = new Logger('AdvanceFormCancel');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents,
    'error-dialog': ErrorDialog
  },
  props: {
    code: {
      type: Number,
      require: true
    },
    page: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    logger.info('Advance cancel')
    const { scrollToTop } = useScreenOperation()
    scrollToTop()

    const errorDialog = ref(false)
    const isDisableSendBtn = ref(false)
    const isError = computed(() => errorDialog)

    const router = useRouter()
    const toBack = () => router.go(-1)
    const store = useStore()
    const clickedSubmit = async () => {
      const { toUserInfoByState, toRiskOfSeriousByState } = useRequestConverter()
      console.log(props.code)
      try {
        isDisableSendBtn.value = false
        const code = Number(props.code)
        const input = {
          jwtToken: store.state.apiParams.jwtToken,
          treatmentConsultationSeq: store.state.apiParams.treatmentConsultationSeq,
          treatmentSerialNumber: store.state.apiParams.treatmentSerialNumber,
          userInfo: toUserInfoByState(store),
        }
        if (code === 102) {
          await store.dispatch('advanceInterview/processInterviewAnswer', {
            ...input,
            statusCode: code,
            riskOfSerious: toRiskOfSeriousByState(store)
          })
        } else {
          await store.dispatch('advanceInterview/processInterviewAnswer', {
            ...input,
            statusCode: code
          })
        }
        await router.push('/interview/done')
      } catch (e) {
        isDisableSendBtn.value = false
        errorDialog.value = true
        logger.error(e)
      }
    }
    return {
      toBack,
      clickedSubmit,
      errorDialog,
      isError
    }
  }
})
</script>
